export default __webpack_public_path__ + "static/media/img4.79d6064c.png";